
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 0a8 8 0 100 16A8 8 0 008 0zm.645 10.713c-.604-.046-.858-.356-1.333-.635-.261 1.367-.58 2.68-1.524 3.364-.291-2.068.427-3.62.761-5.268-.569-.958.07-2.887 1.27-2.412 1.477.585-1.28 3.555.572 3.936 1.933.39 2.722-3.353 1.524-4.57-1.732-1.757-5.04-.04-4.633 2.474.1.615.734.802.254 1.65-1.108-.246-1.438-1.12-1.396-2.285.07-1.907 1.714-3.243 3.364-3.427 2.087-.233 4.046.766 4.316 2.728.303 2.217-.944 4.616-3.175 4.445z","fill":"currentColor"}})])
          )
        }
      }
    